import React from "react";
import { norecord } from "../Constant/Index";

function Norecord() {
  return (
    <div className="notFound-container">
      <img src={norecord} className="img-fluid" />
    </div>
  );
}

export default Norecord;
